export const EMPTY_STATE_CIRCLE_COLOR = [244 / 255, 246 / 255, 250 / 255];
export const EMPTY_STATE_CIRCLE_SCALE = [190, 190, 100];
export const EMPTY_STATE_CIRCLE_POSITION = [250, 250, 0];

const recolorLayerFills = (value) => {
  if (Array.isArray(value)) {
    return value.map(recolorLayerFills);
  }

  if (!value || typeof value !== "object") {
    return value;
  }

  const clonedValue = Object.fromEntries(
    Object.entries(value).map(([key, child]) => [key, recolorLayerFills(child)]),
  );

  if (value.ty === "fl" && value.c?.k) {
    clonedValue.c = {
      ...clonedValue.c,
      k: [...EMPTY_STATE_CIRCLE_COLOR],
    };
    clonedValue.o = {
      ...clonedValue.o,
      k: 100,
    };
  }

  return clonedValue;
};

const prepareCircleLayer = (layer) => {
  const recoloredLayer = recolorLayerFills(layer);

  return {
    ...recoloredLayer,
    hd: false,
    ks: {
      ...recoloredLayer.ks,
      p: {
        ...recoloredLayer.ks.p,
        k: [...EMPTY_STATE_CIRCLE_POSITION],
      },
      s: {
        ...recoloredLayer.ks.s,
        k: [...EMPTY_STATE_CIRCLE_SCALE],
      },
    },
  };
};

export const withoutEmbeddedEmptyStateCopy = (animation) => {
  const visibleLayers = (animation.layers || []).filter(
    (layer) =>
      layer.nm !== "chatbbl Outlines" &&
      layer.nm !== "Shape Layer 6" &&
      layer.nm !== "Shape Layer 7" &&
      !layer.nm?.startsWith("No Data Found"),
  );
  const circleLayer = visibleLayers.find(
    (layer) => layer.nm === "Shape Layer 1",
  );

  return {
    ...animation,
    layers: [
      ...visibleLayers.filter((layer) => layer.nm !== "Shape Layer 1"),
      ...(circleLayer ? [prepareCircleLayer(circleLayer)] : []),
    ],
  };
};
